import { render, staticRenderFns } from "./ProjectValuationSnapshotFormDialog.vue?vue&type=template&id=23c9cb5b&"
import script from "./ProjectValuationSnapshotFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationSnapshotFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
